module.exports = __webpack_public_path__ + "static/media/Goodnest_ios_2.97c6484f.jpg";